/*@ngInject*/
const UiPerformanceLogRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createUiPerformanceLog = function (log) {
        let url = '/rest/UIPerformanceLogger',
            data = [log];

        return this.post(url, data);
    };
};

angular.module('umCore')
    .service('uiPerformanceLogRepository', UiPerformanceLogRepository);
